import { FC } from "react";
import Link from "next/link";

import { useNewFormsServiceStore } from "@./state";

import Grid from "../../layout/Grid/Grid";
import Column from "../../layout/Column/Column";
import Text from "../../base/Text/Text";
import { AlertPrompt } from "../../feature/AlertPrompt/AlertPrompt";
import Spacer from "../../layout/Spacer/Spacer";

export interface IExistingUserError {
  message?: string;
}

const ExistingUserError: FC<IExistingUserError> = () => {
  const { getFlowFieldErrors } = useNewFormsServiceStore();
  const hasUserExistsError = !!getFlowFieldErrors("fresh-food-new-user", "existingUser", "0")?.length;
  if (!hasUserExistsError) {
    return <></>;
  }
  return (
    <Grid component="FieldsetDefault" className="container mx-auto px-4">
      <Column spans={{ lg: 6 }} offset={{ lg: 4 }}>
        <AlertPrompt
          style="error"
          title="Hi Stranger!"
          hideImage={true}
          size="full"
        >
          <Spacer size="md" />
          <Text size="2xs" align="center">
            It looks like you already have an account with us.{ " " }
            <Link href="/login" className="underline">
              <Text tag="span" size="2xs">
                Log in
              </Text>
            </Link>
            { " " }to continue feeding Fresh effortlessly.
            <Spacer size="lg" />
            <a href="mailto:meow@katkin.com" className="underline">
              <Text tag="span" size="2xs">
                Need help?
              </Text>
            </a>
            { " " }Our lovely Cat Expert team can help you sign up to KatKin.
          </Text>
        </AlertPrompt>
      </Column>
    </Grid>
  );
};

export default ExistingUserError;
